import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { NavigationItem } from '../navigation-tree/navigation-tree.constant';
import { filter, tap } from 'rxjs/operators';
import { animate, style, transition, trigger } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

const timing = '250ms ease';

@Component({
    selector: 'menu-list-container',
    templateUrl: './menu-list-container.component.html',
    styleUrls: ['./menu-list-container.component.scss'],
    animations: [
        trigger('smoothHideAndShow', [
            transition(':enter', [
                style({ height: 0, opacity: 0 }),
                animate(timing, style({ height: '*', opacity: 1 }))
            ]),
            transition(':leave', [
                animate(timing, style({ height: 0, opacity: 0 }))
            ]),
        ])
    ],
    standalone: false
})
export class MenuListContainerComponent implements OnInit {
  private _destroyRef: DestroyRef = inject(DestroyRef);
  public expanded: boolean;

  @Input() item: NavigationItem;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.expanded = this._isActive();
    this.navigationWatch().subscribe();
  }

  navigationWatch(): Observable<NavigationEnd> {
    return this.router.events.pipe(
      takeUntilDestroyed(this._destroyRef),
      filter((event: unknown): event is NavigationEnd => event instanceof NavigationEnd),
      tap(() => this.expanded = this._isActive())
    )
  }

  private _isActive(): boolean {
    return this.router.isActive(this.item.route, {paths: 'subset', queryParams: 'ignored', fragment: 'ignored', matrixParams:'subset'})
  }
}
